import { useEffect, useState } from "react";
import { DataTableHighlightSection } from "../../types/types";
import { GetRequest } from "../../utils/api";
interface Props {
  highlightSections: DataTableHighlightSection[]
}

const HighlightsComponent: React.FC<Props> = ({
  highlightSections
}) => {

  const [sectionsInfo, setSectionsInfo] = useState<Map<string, string>>(new Map());

  useEffect(() => {

    if (highlightSections) {

      highlightSections.forEach(section => {

        if (section.api) {
          GetRequest(section.api).then((data) => {
            // Process the received data
            try {
              const val = eval(section.apiKey ?? "");
              const updatedMap = new Map(sectionsInfo); // Create a copy of the current Map state
              updatedMap.set(section.label, val); // Update the value for the specified key
              setSectionsInfo(updatedMap); // Update the state with the new Map
            } catch(err) {
              console.error(err);
            }

          });
        }

      });
    }
  }, [highlightSections]);

  return (
    <>
      {Array.from(sectionsInfo.entries()).map(([key, value]) => {
        return `${key}: ${value}`;
      })}

    </>
    );
}

export default HighlightsComponent;